import React from 'react';


export default class Checkbox extends React.Component {

  state = { checked: false };


  handleChange = e => {
    this.props.handleChange({checked:  !this.state.checked, index: this.props.id })
  };

  componentWillMount = () => {
    this.setState({checked: this.props.checked })
  };

  componentWillReceiveProps = newProps => {
    this.setState({checked: newProps.checked })
  };

  shouldComponentUpdate = nexProps => {
    return this.state.checked !== nexProps.checked;
  };

  render(){
    return(
        <div className={this.props.fullWidth ? 'col-12' :'col-6'}>
          <div className="checkbox">
            <input type="checkbox"
                   onChange={this.handleChange}
                   id={this.props.id}
                   name={this.props.name || this.props.label}
                   data-value={this.props.value}
                   checked={this.state.checked}
            />
            <label htmlFor={this.props.id} title={this.props.label}>
              {this.props.label}
            </label>
          </div>
        </div>
      );
  }
}



// WEBPACK FOOTER //
// ./src/blocks/filters/Checkbox.jsx